import LegalDocumentPage from "../LegalDocumentPage/LegalDocumentPage";
import { privacidadeContent } from "./Privacidadecontent";

export default function PoliticaDePrivacidade() {
  return <LegalDocumentPage content={privacidadeContent} />;
}